import { FC, useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

import { KycModal } from "../../modals";
import {
  AdditionalVerificationMessage,
  GetVerifiedMessage,
  LiftLimitMessage,
  // TODO: Uncomment when pilot invoice message is used
  // PilotInvoiceMessage,
} from "../../messages";
// TODO: Uncomment when pilot invoice message is used
// import { CURRENCY_MAP } from "../../../constants";
import { selectCurrentUser } from "../../../store/reducers/user";
import {
  // TODO: Uncomment when pilot invoice message is used
  // CurrencyType,
  Invoice,
} from "../../../types/InvoiceTypes";

type Props = {
  className?: string;
  invoice?: Invoice;
  orientation?: "vertical" | "horizontal";
  text?: string;
};

export const VerifyForm: FC<Props> = ({
  className,
  invoice,
  orientation = "vertical",
  text,
}) => {
  const [showModal, setShowModal] = useState(false);

  const {
    kyc_complete,
    kyc_complete_and_approved,
    kyc_second_level_complete,
    onmeta_kyc_required,
    onmeta_kyc_complete,
  } = useSelector(selectCurrentUser);

  // TODO: Uncomment when pilot invoice message is used
  // const outgoingCurrency = invoice
  //   ? CURRENCY_MAP[invoice.outgoing_currency!]
  //   : undefined;

  const message = (() => {
    if (!kyc_complete || (onmeta_kyc_required && !onmeta_kyc_complete)) {
      // TODO: Uncomment when pilot invoice message is used
      // if (
      //   invoice?.user_is_issuer &&
      //   outgoingCurrency?.type === CurrencyType.CRYPTO
      // ) {
      //   return (
      //     <PilotInvoiceMessage
      //       invoice={invoice}
      //       onClick={() => setShowModal(true)}
      //     />
      //   );
      // }

      return (
        <GetVerifiedMessage text={text} onClick={() => setShowModal(true)} />
      );
    }

    if (!kyc_complete_and_approved || kyc_second_level_complete) {
      return <AdditionalVerificationMessage orientation={orientation} />;
    }

    return (
      <LiftLimitMessage
        orientation={orientation}
        onClick={() => setShowModal(true)}
      />
    );
  })();

  const kyc_ongoing =
    kyc_complete &&
    (!onmeta_kyc_required || onmeta_kyc_complete) &&
    (!kyc_complete_and_approved || kyc_second_level_complete);

  return (
    <>
      <div
        className={classNames(kyc_ongoing ? "" : "cursor-pointer", className)}
        data-test="verify-identity-to-send-invoices"
      >
        {message}
      </div>

      <KycModal isOpen={showModal} close={() => setShowModal(false)} />
    </>
  );
};
